var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "side-drawer",
    {
      attrs: {
        open: _vm.open,
        title: _vm.titleText,
        icon: "ni-filter-fill",
        size: _vm.resolvedSize,
        "overlay-class": "sip-filter-sheet-overlay",
        "drawer-class": "sip-filter-sheet",
        "close-label": _vm.trans("general.cancel"),
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u(
        [
          _vm.showApply || _vm.showReset || _vm.$slots.footer
            ? {
                key: "footer",
                fn: function () {
                  return [
                    _vm._t("footer", function () {
                      return [
                        _vm.showReset
                          ? _c(
                              "button",
                              {
                                staticClass: "btn sip-filter-sheet-reset",
                                attrs: { type: "button" },
                                on: { click: _vm.reset },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.resetText) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showApply
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary sip-filter-sheet-apply",
                                attrs: { type: "button" },
                                on: { click: _vm.apply },
                              },
                              [
                                _c("em", {
                                  staticClass: "icon ni ni-check-circle me-1",
                                }),
                                _vm._v(
                                  " " + _vm._s(_vm.applyText) + "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "div",
        { staticClass: "sip-filter-sheet-fields" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }